(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.gh-header details[open]').forEach(function(item){item.open=false;item.querySelector('summary').focus();});}});
document.addEventListener('click',function(event){document.querySelectorAll('.gh-header details[open]').forEach(function(item){if(!item.contains(event.target)){item.open=false;}});});

  } catch(e) { console.error(e); }
})();
})();
